import { render, staticRenderFns } from "./IbDataTable.vue?vue&type=template&id=540470ad"
import script from "./IbDataTable.vue?vue&type=script&lang=js"
export * from "./IbDataTable.vue?vue&type=script&lang=js"
import style0 from "./IbDataTable.vue?vue&type=style&index=0&id=540470ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports